import React from 'react';
import { LinkedModal } from '../../form/search/LinkedModal';

export const EqMagModal = ({
  title,
  desc,
}) => ({
  title,
  body: (
    <div>
      <div>
        Valid values:
        {' '}
        <b>0.0 to 9.9</b>
      </div>
      <br />
      <p>
        {desc}
      </p>
      <p>
        The magnitude is a measure of seismic energy. The magnitude scale is logarithmic. An increase of one in magnitude represents a tenfold increase in the recorded wave amplitude. However, the energy release associated with an increase of one in magnitude is not tenfold, but about thirtyfold. For example, approximately 900 times more energy is released in an earthquake of magnitude 7 than in an earthquake of magnitude 5. Each increase in magnitude of one unit is equivalent to an increase of seismic energy of about 1.6 x 10,000,000,000,000 ergs.
      </p>
      <LinkedModal helpModalId="eqMagnitude">Back</LinkedModal>
    </div>
  ),
});
